module.exports = __webpack_public_path__ + "static/img/index.6f8043f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/BY-S07D/index.png
// module id = Bne5
// module chunks = 0